import { render, staticRenderFns } from "./inventoryLossForm.vue?vue&type=template&id=110b28fa&scoped=true&"
import script from "./inventoryLossForm.vue?vue&type=script&lang=js&"
export * from "./inventoryLossForm.vue?vue&type=script&lang=js&"
import style0 from "./inventoryLossForm.vue?vue&type=style&index=0&id=110b28fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110b28fa",
  null
  
)

export default component.exports